// extracted by mini-css-extract-plugin
module.exports = {"dpu-calculator-footer":"Footer_dpu-calculator-footer__5XLlh"};